import {React,useState,useEffect} from 'react'
import './ListTable.css';
import axios from 'axios';
import Moment from 'moment';
export default function LeaveListView() {
    const [data, setData ] = useState([])
    useEffect(()=>{
        fetchAllData()
    },[])
    const fetchAllData = () =>{
        axios({
            method: 'get',
            url: `http://127.0.0.1:8000/leave/fetchAllLeave`,
            withCredentials: false,
            headers: { 'Content-Type': 'application/x-www-form-urlencoded','Access-Control-Allow-Origin' : '*' },
          }).then(response => {
            setData(response.data.data);
        })
        .catch(error => {
            console.error(error);
        });
    }
    return(
        <div>
            <table className="listview-leave">
                <thead>
                    <tr>
                        <th>Leave Type</th>
                        <th>Requested Date</th>
                        <th>From Date</th>
                        <th>To Date</th>
                        <th>Duration</th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        data.length ? data.map((val)=>{
                            return(
                            <tr>
                                <td>{val.leave_type}</td>
                                <td>{Moment(val.created_timestamp).format('DD-MM-YYYY')}</td>
                                <td>{Moment(val.from_date).format('DD-MM-YYYY')}</td>
                                <td>{Moment(val.to_date).format('DD-MM-YYYY')}</td>
                                <td>{val.duration}</td>
                                <td>{val.status}</td>
                            </tr>
                            )
                            }) : ''
                    }
                </tbody>
            </table>
        </div>
    )
}